import React from "react";
import { AHText, Circle } from "arkh";
import { ColumnItem, RowItem } from "./components";
import { useWeekdays } from "../../../common/useWeekdays";

export function OccasionHeaderItem({ weekday }: { weekday: number }) {
  const weekdays = useWeekdays("narrow");
  return (
    <ColumnItem color="background">
      <RowItem
        first
        color="background"
        style={{ justifyContent: "center", alignItems: "center" }}
      >
        <Circle
          size="medium"
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
          color="primary"
        >
          <AHText type="subtitle" color="lightText">
            {weekdays[weekday]}
          </AHText>
        </Circle>
      </RowItem>
    </ColumnItem>
  );
}
